import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyDialogWrapperComponent } from './lazy-dialog-wrapper.component';

/**
 * Encapsulated feature module for LazyDialogWrapperComponent, providing dynamic code-splitting
 * and shimmer skeleton loading for MatDialog instances.
 */
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    LazyDialogWrapperComponent
  ],
  exports: [
    LazyDialogWrapperComponent
  ],
  entryComponents: [
    LazyDialogWrapperComponent
  ]
})
export class LazyDialogWrapperModule {}
export { LazyDialogWrapperComponent };
